module.exports = __webpack_public_path__ + "img/gl-logo.fee7b6d3.png";